import api from "../utils/api";
import {
  GET_EMPLOYEE, GET_EMPLOYEES, LOGOUT
} from "./types";
import { send as sendAlert } from "./alert";
import { valid } from "../utils/date";
import { isGuid } from "../utils/string";

export const save = (value) => async (dispatch) => {
    try {
        const res = await api.post(`/employees/me`, value);
        dispatch(sendAlert("Saved succesfully", "success"));
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const update = (value) => async (dispatch) => {
    try {
        const res = await api.post(`/employees/i/${value.uuid}`, value);
        dispatch(sendAlert("Saved succesfully", "success"));
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const get = (uuid) => async (dispatch) => {
    try {
        const res = await api.get(`/employees/i/${isGuid(uuid) ? uuid : "me"}`);
        dispatch({
            type: GET_EMPLOYEE,
            payload: res.data,
        });
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const list = () => async (dispatch) => {
    try {
        const res = await api.get(`/employees/firm`);
        dispatch({
            type: GET_EMPLOYEES,
            payload: res.data,
        });
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const table = ({page, size, order, direction, dateStart, dateEnd, active=null, search=""}) => async (dispatch) => {
    try {
        const url = valid(dateStart) && valid(dateEnd) ? `/employees/l/p/${page}/s/${size}/o/${order}/${direction}/dt/${dateStart}/${dateEnd}/${search}` : `/employees/l/p/${page}/s/${size}/o/${order}/${direction}/a/${active || "0"}/${search}`;
        const res = await api.get(url);

        dispatch({
            type: GET_EMPLOYEES,
            payload: res.data,
        });

        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};
